// removed by extract-text-webpack-plugin
module.exports = {"flexWrapper":"TaskTemplateListOverview__flexWrapper__3ZKGE","noShadow":"TaskTemplateListOverview__noShadow__1ukd-","areaSelection":"TaskTemplateListOverview__areaSelection__2fHe0","icon":"TaskTemplateListOverview__icon__1Gh_m","title":"TaskTemplateListOverview__title__3IGHA"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListOverview.scss
// module id = 1929
// module chunks = 0